const MAP_ICON_VIEW_SETTING_LOCAL_STORAGE_KEY = 'mapViewIconPreference';

const getMapIconPreference = (): boolean => {
  const mapIconPreferenceJson = localStorage.getItem(MAP_ICON_VIEW_SETTING_LOCAL_STORAGE_KEY);

  if (!!mapIconPreferenceJson) {
    const localInitialInsightsDateRange = (JSON.parse(mapIconPreferenceJson));
    return !!localInitialInsightsDateRange;
  }

  return false;
};

const setMapIconPreference = (markersVisible: boolean) => {
  localStorage.setItem(MAP_ICON_VIEW_SETTING_LOCAL_STORAGE_KEY, JSON.stringify(markersVisible));
};


export { getMapIconPreference, setMapIconPreference, MAP_ICON_VIEW_SETTING_LOCAL_STORAGE_KEY };
